import { styled } from '@mui/material/styles';
import { InfoIcon } from '@phosphor-icons/react/Info';

export const StyledInfoIcon = styled(InfoIcon)`
  color: ${({ theme }) => theme.palette.info.main};
  height: ${({ theme }) => theme.spacing(2.25)};
  width: ${({ theme }) => theme.spacing(2.25)};
  margin-right: ${({ theme }) => theme.spacing(1)};
  padding: ${({ theme }) => theme.spacing(0.5, 0.25)};
  transform: translateY(30%);
`;
